// extracted by mini-css-extract-plugin
var _1 = "UserProfileView-module__animateUploadProgressBarWidth--eq_YF";
var _2 = "UserProfileView-module__animatedBackground--Jyr9Q";
var _3 = "UserProfileView-module__aside--h_qgG";
var _4 = "UserProfileView-module__asideHeader--htsln";
var _5 = "UserProfileView-module__asideSection--EZfIF";
var _6 = "UserProfileView-module__container--vIYsX";
var _7 = "UserProfileView-module__controls--cO0bA";
var _8 = "UserProfileView-module__controlsBar--P6T1X";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "aside", _4 as "asideHeader", _5 as "asideSection", _6 as "container", _7 as "controls", _8 as "controlsBar" }
